export function createTrack(options) {
    return {
        id: options.id ?? generateTrackId(options.name),
        name: options.name,
        kind: options.kind,
        index: options.index ?? 0,
        muted: options.muted ?? false,
        locked: options.locked ?? false,
        visible: options.visible ?? true,
    };
}
function generateTrackId(name) {
    const slug = name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    return `${slug}-${Math.random().toString(36).slice(2, 8)}`;
}
//# sourceMappingURL=track.js.map